import React, { useContext, useEffect } from 'react';
import TablePlan from './TablePlan';
import { RouteComponentProps } from 'react-router-dom';
import { Modify } from 'utils/types';
import { ReservationContext } from 'Contexts/ReservationContext';
import { AuthContext } from 'Contexts/AuthContext';
import useAlert from 'CustomHooks/useAlert';

export type TablePlanContainerProps = Modify<
  RouteComponentProps,
  {
    match: { params: { date: string; restaurantId: string } };
  }
>;

const TablePlanContainer: React.FC<TablePlanContainerProps> = ({
  history,
  match,
}) => {
  const { date, restaurantId } = match.params;

  const { setrestaurantId } = useContext(AuthContext);
  const { setdate, TablePlanAssistant } = useContext(ReservationContext);
  const alert = useAlert();

  const goToDate = async (newDate: string) => {
    if (TablePlanAssistant.active) {
      await TablePlanAssistant.clearChanges();
      TablePlanAssistant.close();
    }

    history.push(`/${restaurantId}/reservations/${newDate}/tablePlan`);
  };

  const onDateChange = (newDate: string) => {
    if (newDate === date) return;

    if (TablePlanAssistant.changes.length) {
      alert({
        title: 'Entwurfsänderungen verwerfen?',
        description:
          'Wenn du den Tag wechselst, werden alle Änderungen des Reservierungs-Assistenten entfernt.',
        severity: 'warning',
        submitLabel: 'Tag wechseln',
        onSubmit: () => {
          goToDate(newDate);
        },
      });
      return;
    }

    goToDate(newDate);
  };

  useEffect(() => {
    setdate(match.params.date);
    setrestaurantId(restaurantId);
  }, [match.params, setdate]);

  useEffect(() => {
    let el = document.getElementsByTagName('body')[0];
    let root = document.documentElement;

    el.classList.add('hideOverflow');
    el.classList.add('tableplanscreen');
    root.classList.add('tableplan-scroll-lock');
    return () => {
      el.classList.remove('hideOverflow');
      el.classList.remove('tableplanscreen');
      root.classList.remove('tableplan-scroll-lock');
    };
  }, []);

  return <TablePlan {...{ date, restaurantId, onDateChange }} />;
};

export default TablePlanContainer;
